import styled from 'styled-components/native'
import { TextInput } from 'react-native-paper'

export const TextField = styled(TextInput)`
  padding-horizontal: 0;
  background-color: transparent;
`
